import {
  TDASearchTermsReportTableFilters,
  TSPSearchTermsReportTableFilters,
} from '../../../models/types'

export const selectSearchTermsTableReportingFilters = ({
  reportingFilters: reportingSearchTermsTableFiltersState,
}: {
  reportingFilters:
    | TSPSearchTermsReportTableFilters
    | TDASearchTermsReportTableFilters
}): TSPSearchTermsReportTableFilters | TDASearchTermsReportTableFilters =>
  reportingSearchTermsTableFiltersState
